import Zone from "@insite/client-framework/Components/Zone";
import toggleFiltersOpen from "@insite/client-framework/Store/Pages/RfqMyQuotes/Handlers/ToggleFiltersOpen";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Filter from "@insite/mobius/Icons/Filter";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { CustomApplicationState } from "@MasterBluePrint/Store/CustomApplicationState";
import { getQuotesDataView,QuotesDataViewContext } from "@MasterBluePrint/Store/Data/Quote/QuoteSelector";
import React, { FC, useContext } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps { }

const mapStateToProps = (state: CustomApplicationState) => ({
    quotesDataView: getQuotesDataView(state, state.rfqMyQuotes.getQuotesParameter),
});

const mapDispatchToProps = {
    toggleFiltersOpen,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & OwnProps;

export interface RfqQuoteHeaderStyles {
    container?: GridContainerProps;
    invoiceCountGridItem?: GridItemProps;
    emptyGridItem?: GridItemProps;
    toggleFilterGridItem?: GridItemProps;
    toggleFilterIcon?: IconPresentationProps;
    toggleFilterClickable?: ClickablePresentationProps;
    quoteCountText?: TypographyPresentationProps;
}

export const headerStyles: RfqQuoteHeaderStyles = {
    container: {
        gap: 8,
        css: css`
            padding-bottom: 20px;

            @media (max-width: 1279px) {

                > div {
                    justify-content: space-between;
                }
            }
        `,
    },
    invoiceCountGridItem: {
        style: { fontWeight: 600 },
        css: css`
            max-width: none;
            flex-basis: unset;
        `,
    },
    toggleFilterGridItem: {
        style: { justifyContent: "flex-end" },
        css: css`
            max-width: none;
            flex-basis: unset;
        `,
    },
    toggleFilterIcon: {
        src: Filter,
        size: 18,
        css: css`
            display: inline-block;
            margin-right: 8px;
        `,
    },
    toggleFilterClickable: {
        css: css`
            padding-left: 15px;
            margin-left: 15px;
            border-left: 1px solid #E4E8F0;
            min-width: 123px;

            &.hide-btn {
                display: none;
            }

            span.label {
                color: #002554;
                font-family: 'Lato',sans-serif;
                font-size: 14px;
                letter-spacing: 0;
            }
        `,
    },
    quoteCountText: {
        css: css`
            color: #002554;
            font-family: 'Roboto', sans-serif;
            font-size: 20px;
            font-weight: 600;
            letter-spacing: 0;
            line-height: 22px;
            white-space: nowrap;
        `,
    }
};
const styles = headerStyles;

const RfqQuoteHeader: FC<Props> = ({ toggleFiltersOpen, quotesDataView }) => {
    // const quotesDataView = useContext(QuotesDataViewContext);
    if (!quotesDataView.value) {
        return null;
    }

    const { pagination } = quotesDataView;

    if (!pagination || pagination.totalItemCount === 0) {
        return null;
    }
    return (
        <GridContainer {...styles.container}>
             <GridItem {...styles.invoiceCountGridItem}>
             <Typography {...styles.quoteCountText} data-test-selector="quote_resultCount">
                    {pagination.totalItemCount} {translate("Quotes")}
                </Typography>
                {/* <Zone contentId={id} zoneName="Content" /> */}
            </GridItem>
            <GridItem {...styles.toggleFilterGridItem}>
                <Clickable
                    {...styles.toggleFilterClickable}
                    onClick={() => toggleFiltersOpen()}
                    data-test-selector="quote_showHideFilters"
                    className={`toggleFilters ${(pagination.totalItemCount === 0) ? "hide-btn" : "show-btn"}`}
                >
                    <Icon {...styles.toggleFilterIcon} />
                    <span className="label">{translate("Filter Quotes")}</span>
                </Clickable>
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(RfqQuoteHeader),
    definition: {
        group: "RFQ My Quotes",
        displayName: "QuoteHeader",
    },
};

export default widgetModule;
